// extracted by mini-css-extract-plugin
module.exports = {"choices":"Choices-module__choices___3NtgA"};